import {useContext, useState, useRef} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, VerticalLineIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { LocaleContext } from '../../../components/LocaleContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { emitOtkOptionCatalogRefresh } from '../../../utils/otkOptionCatalogList';
import {
  buildOtkOptionCatalogWritePayload,
  initialValuesForOtkOptionCatalogForm,
  planOtkOptionCatalogWriteOutcome,
} from '../../../utils/otkOptionCatalogWritePayload';

const RESOURCE = 'root_causes';

export default function RootCauseAdd({root_cause, type="add"}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);

    const closeAfterRef = useRef(false);
    const submitRef = useRef(null);

    const [formRootCause,setFormRootCause] = useState(root_cause);
    const [formType, setFormType] = useState(type);

    const [insertCopyIcon,setInsertCopyIcon] = useState(!user.permissions?.includes('add otk-setup'));

    function addNewRootCause(){
      dispatch({type:'create_new_tab',name: t('RootCauseList.Tab.Add'), translationKey: 'RootCauseList.Tab.Add', legacyLabel: t('RootCauseList.Tab.Add'),page:'RootCauseAdd',props:{root_cause: null,type:'add'},mask:'qlty035'})
    }
    function copyRootCause(){
      dispatch({type:'create_new_tab',name: t('RootCauseList.Tab.Add'), translationKey: 'RootCauseList.Tab.Add', legacyLabel: t('RootCauseList.Tab.Add'),page:'RootCauseAdd',props:{root_cause: null, type:'add'},mask:'qlty035'})
    }

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formik = useFormik({
         initialValues: initialValuesForOtkOptionCatalogForm(RESOURCE, formRootCause, formType),
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            const closeAfter = closeAfterRef.current;
            const formData = buildOtkOptionCatalogWritePayload(RESOURCE, values);
            const url = formType === 'add'
              ? '/api/root_causes'
              : `/api/root_causes/update/${formik.values.id}`;

            postRequest(url, formData, true)
              .then((response) => {
                  const plan = planOtkOptionCatalogWriteOutcome({
                    response,
                    resource: RESOURCE,
                    closeAfter,
                  });

                  if (plan.outcome === 'error' || plan.outcome === 'unknown') {
                    setVisible(false);
                    alert(t('OtkOptionCatalog.Form.ActionFailed'));
                    return;
                  }

                  if (plan.canonicalValues) {
                    setFormRootCause(plan.canonicalValues);
                    formik.setValues(plan.canonicalValues);
                  }
                  if (plan.outcome === 'created') {
                    setFormType('edit');
                  }

                  if (plan.shouldEmit) {
                    emitOtkOptionCatalogRefresh({
                      resource: RESOURCE,
                      action: plan.emitAction,
                      id: response?.data?.id ?? plan.canonicalValues?.id ?? null,
                    });
                  }

                  if (plan.shouldToast) {
                    const detail = plan.outcome === 'created'
                      ? t('Common.Toast.RecordSavedDetail')
                      : t('Common.Toast.RecordUpdatedDetail');
                    toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail });
                  }

                  if (plan.shouldClose) {
                    dispatch({type:'close_tab',id:state.selectedTab});
                  }
                  setVisible(false);
              }).catch(() => {
                  setVisible(false);
                  alert(t('OtkOptionCatalog.Form.ActionFailed'));
              });
      },
    });

    return (
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
      <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => { closeAfterRef.current = true; submitRef.current.click(); }}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => { closeAfterRef.current = false; submitRef.current.click(); }}><SaveIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewRootCause()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyRootCause()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button onClick={() => openFavoriteDialog(t('RootCauseList.FavoriteTitle'),"RootCauseAdd")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("RootCauseAdd",null,null)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        </IntersectionObserverWrapper>
      </div>
        <form onSubmit={formik.handleSubmit}>
            <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
                <div className='xl:grid grid-cols-2 gap-1 mb-2'>
                    <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                        <h1 className="text-3xl font-semibold text-left text-zinc-900">
                            {t('RootCauseAdd.Heading')}
                        </h1>

                        {formType === "edit" && (
                            <label className="block text-md font-semibold text-gray-800">
                                {t('OtkOptionCatalog.Form.SerialNumber', { id: formik.values.id })}
                            </label>
                        )}

                        <div>
                            <label className="block text-md font-semibold text-gray-800">{t('RootCauseAdd.NameSk')}</label>
                            <input
                                name="name.sk"
                                type="text"
                                required
                                onChange={formik.handleChange}
                                value={formik.values.name?.sk ?? ''}
                                className="block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-md font-semibold text-gray-800">{t('RootCauseAdd.NameDe')}</label>
                            <input
                                name="name.de"
                                type="text"
                                required
                                onChange={formik.handleChange}
                                value={formik.values.name?.de ?? ''}
                                className="block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-md font-semibold text-gray-800">{t('RootCauseAdd.NameEn')}</label>
                            <input
                                name="name.en"
                                type="text"
                                required
                                onChange={formik.handleChange}
                                value={formik.values.name?.en ?? ''}
                                className="block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none"
                            />
                        </div>

                        <button type="submit" ref={submitRef} className='hidden'></button>
                    </div>
                </div>
            </div>
        </form>
            </>
            );
}
